module.exports = __webpack_public_path__ + "static/media/pointing-down-finger.0f976783.svg";